export default "__VITE_ASSET__B8N9rH4H__"